/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Learn_C2_TitleInputs */

const en_cad_learn_c2_title = /** @type {(inputs: Cad_Learn_C2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit with precision`)
};

/**
* | output |
* | --- |
* | "Edit with precision" |
*
* @param {Cad_Learn_C2_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_learn_c2_title = /** @type {((inputs?: Cad_Learn_C2_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Learn_C2_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_learn_c2_title(inputs)
});
export { cad_learn_c2_title as "cad.learn.c2_title" }